import React from "react";
import {Route} from "react-router-dom";
import {Content} from "./Content";
import swal from "sweetalert";

function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key)

  // if the item doesn't exist, return null
  if (!itemStr) {
      return null
  }

  const item = JSON.parse(itemStr)
  const now = new Date()

  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
        swal({
          title: "Sesi anda telah selesai, silahkan login kembali!",
          // text: "Lanjut simpan target masa studi Profesi?",
          icon: "warning",
          // buttons: true,
          dangerMode: false,
          }).then((willDelete)=>{
            window.localStorage.clear();
            window.location.reload();
      })
      return null
  }
  return item.value
}

export function ContentRoute({ children, component, render, ...props }) {
  getWithExpiry("statlogin");
  return (
    <Route {...props}>
      {routeProps => {
        if (typeof children === "function") {
          return <Content>{children(routeProps)}</Content>;
        }
        // console.log(routeProps);
        if (!routeProps.match) {
          return null;
        }

        if (children) {
          return <Content>{children}</Content>;
        }

        if (component) {
          return (
            <Content>{React.createElement(component, routeProps)}</Content>
          );
        }

        if (render) {
          return <Content>{render(routeProps)}</Content>;
        }

        return null;
      }}
    </Route>
  );
}
